import { conTransiciones } from './tourUi'

// ui: null | 'create' (modal crear) | 'saving' (modal movimiento del primer ahorro)
export function getAhorroSteps({ t, hasPersonales, hasCompartidos, setUi }) {
  const steps = [
    {
      element: '[data-tour="ahorro-resumen"]',
      popover: { title: t('tour_aho_resumen_t'), description: t('tour_aho_resumen_d'), side: 'bottom' }
    },
    {
      element: '[data-tour="ahorro-nuevo"]',
      popover: { title: t('tour_aho_nuevo_t'), description: t('tour_aho_nuevo_d'), side: 'bottom' }
    },
    {
      ui: 'create',
      element: '[data-tour="ahorro-tipo"]',
      popover: { title: t('tour_aho_tipo_t'), description: t('tour_aho_tipo_d'), side: 'bottom' }
    },
    {
      ui: 'create',
      element: '[data-tour="ahorro-datos"]',
      popover: { title: t('tour_aho_datos_t'), description: t('tour_aho_datos_d'), side: 'bottom' }
    },
    {
      ui: 'create',
      element: '[data-tour="ahorro-compartir"]',
      popover: { title: t('tour_aho_compartir_t'), description: t('tour_aho_compartir_d'), side: 'top' }
    },
    ...(hasPersonales ? [
      {
        element: '[data-tour="ahorro-personales"]',
        popover: { title: t('tour_aho_personales_t'), description: t('tour_aho_personales_d'), side: 'bottom' }
      },
      {
        ui: 'saving',
        element: '[data-tour="ahorro-mov-monto"]',
        popover: { title: t('tour_aho_mov_monto_t'), description: t('tour_aho_mov_monto_d'), side: 'bottom' }
      },
      {
        ui: 'saving',
        element: '[data-tour="ahorro-mov-comprobante"]',
        popover: { title: t('tour_aho_mov_comprobante_t'), description: t('tour_aho_mov_comprobante_d'), side: 'bottom' }
      },
      {
        ui: 'saving',
        element: '[data-tour="ahorro-mov-acciones"]',
        popover: { title: t('tour_aho_mov_acciones_t'), description: t('tour_aho_mov_acciones_d'), side: 'top' }
      }
    ] : []),
    ...(hasCompartidos ? [
      {
        element: '[data-tour="ahorro-compartidos"]',
        popover: { title: t('tour_aho_compartidos_t'), description: t('tour_aho_compartidos_d'), side: 'bottom' }
      }
    ] : []),
    ...(!hasPersonales && !hasCompartidos ? [
      {
        element: '[data-tour="ahorro-vacio"]',
        popover: { title: t('tour_aho_vacio_t'), description: t('tour_aho_vacio_d'), side: 'top' }
      }
    ] : [])
  ]
  return conTransiciones(steps, setUi)
}